var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "download--content" },
    [
      _c("div", { staticClass: "download--content-header" }, [
        _c("header", { staticClass: "header-content" }, [
          _c("div", { staticClass: "headline" }, [
            _c(
              "button",
              {
                staticClass: "menu-toggler",
                on: {
                  click: function ($event) {
                    return _vm.toggleResponsiveMenu()
                  },
                },
              },
              [_c("i", { staticClass: "icon-menu" })]
            ),
            _vm._v(" "),
            _c("h2", { staticClass: "heading" }, [
              _vm._v(_vm._s(_vm.labels.categories)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [
          _c("div", { staticClass: "entries" }, [
            _c("div", { staticClass: "count--with-label" }, [
              _c("span", [_vm._v(_vm._s(_vm.filteredItems.length))]),
              _vm._v(_vm._s(_vm.labels.files)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "search-input input-border-radius" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search",
                },
              ],
              domProps: { value: _vm.search },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.search = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("i", { staticClass: "icon-search" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "layout-switch" }, [
            _c("div", { staticClass: "btn--group" }, [
              _c(
                "a",
                {
                  class: { active: _vm.isGrid },
                  on: {
                    click: function ($event) {
                      return _vm.changeLayout("grid", $event)
                    },
                  },
                },
                [_c("i", { staticClass: "icon-ui-grid" })]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  class: { active: !_vm.isGrid },
                  on: {
                    click: function ($event) {
                      return _vm.changeLayout("list", $event)
                    },
                  },
                },
                [_c("i", { staticClass: "icon-ui-list" })]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "download--content-main" },
        [
          _vm.paginatedData.length == 0
            ? _c("div", { staticClass: "info--box info-grey" }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.labels.empty) + "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isGrid
            ? _c("div", { staticClass: "grid col-custom-2" }, [
                _c(
                  "div",
                  { staticClass: "row row--dense-sm" },
                  _vm._l(_vm.paginatedData, function (item, i) {
                    return _c(
                      "div",
                      {
                        key: `item-${i}`,
                        staticClass:
                          "col-12 col-sm-6 col-md-4 col-xl-3 col-item",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "download--item hover--shadow-transition",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "image__container",
                                class: { "is--icon": !item.isImage },
                                on: {
                                  click: function ($event) {
                                    return _vm.showLightbox(item)
                                  },
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "image",
                                  style: {
                                    "background-image":
                                      "url(" +
                                      (item.isImage ? item.image : item.icon) +
                                      ")",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.title) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "date typo-sublabel" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.date) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "type typo-sublabel" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.type) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._m(0, true),
                            ]),
                            _vm._v(" "),
                            _c("a", {
                              attrs: {
                                href: item.link,
                                download: item.fileName,
                                target: "_blank",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isGrid
            ? _c("div", { staticClass: "list" }, [
                _c(
                  "ul",
                  { staticClass: "list-unstyled" },
                  _vm._l(_vm.paginatedData, function (item, i) {
                    return _c(
                      "li",
                      {
                        key: `item-hover-${i}`,
                        staticClass: "hover--shadow-transition",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "image__container",
                            on: {
                              click: function ($event) {
                                return _vm.showLightbox(item)
                              },
                            },
                          },
                          [
                            _c("div", {
                              staticClass: "image",
                              style: {
                                backgroundImage: "url(" + item.icon + ")",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "infos" }, [
                          _c("div", { staticClass: "title item" }, [
                            _c(
                              "span",
                              { staticClass: "d-block text-truncate" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.title) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "type item typo-sublabel" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.type) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "date item typo-sublabel" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(item.date) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(1, true),
                        _vm._v(" "),
                        _c("a", {
                          attrs: {
                            href: item.link,
                            target: "_blank",
                            download: item.fileName,
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.filteredItems.length > 0
            ? _c("pagination", {
                attrs: {
                  "label-previous": _vm.labels.previous,
                  "label-next": _vm.labels.next,
                  "label-page": _vm.labels.page,
                  "label-pagination": _vm.labels.of,
                  "total-pages": _vm.totalPages,
                  total: _vm.filteredItems.length,
                  "per-page": _vm.resultsPerPage,
                  "current-page": _vm.currentPage,
                },
                on: { "page-changed": _vm.pageChanged },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("vue-lightbox", {
        attrs: { images: _vm.lightbox.items },
        model: {
          value: _vm.lightbox.index,
          callback: function ($$v) {
            _vm.$set(_vm.lightbox, "index", $$v)
          },
          expression: "lightbox.index",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "action" }, [
      _c("i", { staticClass: "icon-ui-download" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "action item" }, [
      _c("i", { staticClass: "icon-ui-download" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }